import Vue from 'vue';
import component_info_content from './base_info_window';
import component_info_mark from './base_mark_content';
let componentInfoMark = Vue.extend(component_info_mark);
let componentInfoContent = Vue.extend(component_info_content);
let $content = {};
let $mark = {};

const createMarkEl = (data, amap, vue_dom) => {
  if(vue_dom){
    componentInfoMark = Vue.extend(vue_dom);
  }
  $mark = new componentInfoMark({
    el: document.createElement('div'),
    data: {
      markData: data
    }
  });
  $mark.markData = data;
  return $mark.$el;
};

// 创建窗体元素  vue_dom自定义窗体
const createEl = (data, amap, vue_dom) => {
  if(vue_dom){
    componentInfoContent = Vue.extend(vue_dom);
  }
  $content = new componentInfoContent({
    el: document.createElement('div'),
    data: {
      allData: data
    }
  });
  $content.allData = data;
  return $content.$el;

};

//创建信息窗体
const createInfoWindow = (data, amap, vue_dom) => {
  let $el = createEl(data, amap, vue_dom);//创建窗体html
  let $markEl = createMarkEl(data, amap, vue_dom);//创建窗体html
  let createInfoWindow = (content) => {
    return content;
  };
  // 创建 infoWindow 实例
  let infoWindow = new AMap.InfoWindow({
    isCustom: true,
    content: createInfoWindow($el),
    offset: new AMap.Pixel(16, -20)
  });
  return infoWindow;
};

//创建mark
const createInfoMark = (data, amap, icon) => {
  let infoMark = new AMap.Marker({
    position: [data.longitude, data.latitude],
    offset: new AMap.Pixel(-10, -10)
  });
  if(icon){
    infoMark.setIcon(icon)
  }else{
    // 创建 infoWindow 实例
    let $markEl = createMarkEl(data, amap);//创建窗体html
    infoMark.setContent($markEl);
  }
  return infoMark;
};

export default {
  createInfoWindow,
  createInfoMark
}



// WEBPACK FOOTER //
// ./src/page/main_content/map/baseMap/base_amap_fn.js